import { Chip, ChipProps } from "@mui/material";
import { styled } from "@mui/material/styles";

/**
 * Styled chip for displaying clinic names with border-only blue styling.
 * Used in practitioner lists and forms.
 */
export const ClinicChip = styled(Chip)(({ theme }) => ({
  height: 24,
  borderRadius: theme.spacing(1.5),
  border: "1px solid",
  borderColor: theme.palette.info.main,
  backgroundColor: "transparent",
  color: theme.palette.info.main,
  "& .MuiChip-label": {
    fontSize: theme.typography.caption.fontSize,
    fontWeight: theme.typography.body2.fontWeight,
    padding: theme.spacing(0, 1),
  },
}));

/**
 * Styled chip for multi-select autocomplete with delete functionality.
 * Primary blue color with delete icon support.
 */
export const ClinicChipWithDelete = styled(Chip)(({ theme }) => ({
  height: theme.spacing(3),
  borderRadius: theme.spacing(1.5),
  border: "1px solid",
  borderColor: theme.palette.primary.main,
  backgroundColor: "transparent",
  color: theme.palette.primary.main,
  "& .MuiChip-label": {
    fontSize: theme.typography.body2.fontSize,
    fontWeight: theme.typography.body2.fontWeight,
    padding: theme.spacing(0, 1),
  },
  "& .MuiChip-deleteIcon": {
    width: theme.spacing(2),
    height: theme.spacing(2),
    color: theme.palette.primary.main,
    "&:hover": {
      color: theme.palette.primary.dark,
    },
  },
}));

export type { ChipProps as ClinicChipProps };
